import { useNavigate } from "react-router-dom"
import { DASHBOARD } from "../../routes/CONSTANTS"
import { Button } from "@mui/material"

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[60vh] text-center p-6">
      <h1 className="text-8xl font-bold text-primary1-600 m-0 leading-none">
        404
      </h1>
      <p className="text-lg text-secondary-500 mt-4 mb-8">
        The page you are looking for does not exist.
      </p>
      <Button
        type="button"
        className="primaryButton"
        onClick={() => navigate(DASHBOARD)}
      >
        Back to Dashboard
      </Button>
    </div>
  )
}

export default NotFound
